module.exports = __webpack_public_path__ + "static/media/29DUNON14.b1546f0d.jpg";